module.exports = __webpack_public_path__ + "img/resc_5kl.897273ca.jpg";